import Com from "components/styledComp/CommStyledComp";
import React from "react";
import 에스마리나_표 from "assets/images/에스마리나_표.png"
import CompImg from "./CompImg";

const CompetitorsMain = () => {
    return(
        <Com.DivDetailSection2 border="true">
            <div className="strategy">
                <h3>경쟁사/경쟁 우위</h3>
                <CompImg img={에스마리나_표} width="80%" height="auto"/>
            </div>
        </Com.DivDetailSection2>
    );
}

export default CompetitorsMain;